/** SVG title accepts text nodes; HTML integration points keep the HTML raw-text guard. */
export function isSvgTitle(html, namespace) {
    if (namespace !== 'svg')
        return false;
    const stack = [];
    let inSvg = true;
    let titleInSvg = false;
    const tags = html
        .replace(/<!--[\s\S]*?-->/g, '')
        .matchAll(/<(\/?)(svg|foreignobject|desc|title)\b[^>]*>/gi);
    for (const match of tags) {
        const tag = match[2]?.toLowerCase();
        if (!tag)
            continue;
        if (match[1]) {
            const index = stack.map((entry) => entry.tag).lastIndexOf(tag);
            if (index >= 0) {
                inSvg = stack[index]?.svg ?? true;
                stack.length = index;
            }
            continue;
        }
        if (tag === 'title')
            titleInSvg = inSvg;
        if (match[0].endsWith('/>'))
            continue;
        stack.push({ tag, svg: inSvg });
        inSvg = tag === 'svg';
    }
    return titleInSvg;
}
//# sourceMappingURL=render-template-namespace.js.map